module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.systemsStatuses
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.systemName))]), _vm._v(" "), _c('td', [(props.item.systemStatus === 'UP') ? _c('v-btn', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v(" " + _vm._s(props.item.systemStatus) + " ")]) : _vm._e(), _vm._v(" "), (props.item.systemStatus === 'DOWN') ? _c('v-btn', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v(" " + _vm._s(props.item.systemStatus) + " ")]) : _vm._e()], 1)]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getSystemStatus
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34dfc0c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/systemstatus.vue
// module id = 1049
// module chunks = 2